import { Link } from "react-router-dom";
import { NAV_LINKS } from "@/data/content";
import { WHATSAPP_NUMBER } from "@/lib/api";
import { Cta } from "@/components/site/ui";
import { LogoMark } from "@/components/site/LogoMark";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/spherioliving/", testid: "footer-social-instagram" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/p/SpherioLiving-61593647353806/", testid: "footer-social-facebook" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1C1A17] text-white">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 pt-20 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <LogoMark size={44} />
            <div className="font-head text-3xl font-extrabold tracking-tight">SPHERIO LIVING<span className="text-[#B8935A]">.</span></div>
          </div>
          <p className="mt-5 max-w-sm text-white/60 leading-relaxed">
            Designing the future of living. Premium modular kitchens, wardrobes and full home
            interiors — engineered with technology and delivered on time.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Cta to="/book-consultation" variant="light" data-testid="footer-book-cta">
              Book Free Consultation
            </Cta>
            <div className="flex items-center gap-2 pl-1">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Spherio Living on ${s.label}`}
                  data-testid={s.testid}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/75 transition-[transform,color,border-color,background-color] duration-300 hover:-translate-y-0.5 hover:text-[#B8935A] hover:border-[#B8935A]"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <div className="text-[11px] tracking-[0.28em] uppercase text-white/40 font-bold">Explore</div>
          <ul className="mt-6 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/70 hover:text-white transition-colors duration-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] tracking-[0.28em] uppercase text-white/40 font-bold">Get in touch</div>
          <ul className="mt-6 space-y-4 text-white/70">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-white/50" /> +91 {WHATSAPP_NUMBER}
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-white/50" /> hello@spherioliving.com
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 text-white/50 mt-1" /> SCO No. 222, Shopping Square 1, Sector D, Sushant Golf City, Lucknow 226030
            </li>
          </ul>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/40">
        <p>© {new Date().getFullYear()} Spherio Living Interiors. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <Link
            to="/privacy-policy"
            data-testid="footer-privacy-link"
            className="hover:text-white transition-colors"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-white transition-colors"
          >
            Terms &amp; Conditions
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
